import { render, staticRenderFns } from "./SalonInfoListing.vue?vue&type=template&id=c7cbe8a8&scoped=true&"
import script from "./SalonInfoListing.vue?vue&type=script&lang=js&"
export * from "./SalonInfoListing.vue?vue&type=script&lang=js&"
import style0 from "./SalonInfoListing.vue?vue&type=style&index=0&id=c7cbe8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cbe8a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VChip,VProgressCircular})
